/**
 * Промпт для нейросети: как попросить ответ в Markdown, чтобы импорт собрал из него
 * документ без ручных правок.
 */

import { DEFAULT_PROFILE } from '../profiles';
import type { Profile } from '../profiles/types';

export function markdownPrompt(profile: Profile = DEFAULT_PROFILE): string {
  const fence = '`'.repeat(3);
  return [
    `Оформи ответ в Markdown по правилам ниже — из него автоматически соберётся документ Word по ${profile.name}. Пиши только текст работы, без вступлений и комментариев от себя.`,
    '',
    'Структура',
    '- Первая строка — название работы: «# Название». Титульный лист не пиши: вуз, вид работы, исполнителя, город и год укажут при сборке документа.',
    '- Разделы — «## », подразделы — «### ». Номера разделов не пиши: они проставятся сами.',
    '- Введение, заключение и список источников — отдельными разделами: «## Введение», «## Заключение», «## Список использованных источников».',
    '- Приложения — «## Приложение А. Название», «## Приложение Б. Название».',
    '',
    'Текст',
    '- Обычные абзацы: без эмодзи, HTML, горизонтальных линий и цитат «>». Жирный шрифт не используй.',
    '- Перечисления — списком «- », нумерованным «1. » — только если важен порядок; не глубже двух уровней.',
    '- Ссылки на источники — номером в квадратных скобках: [1], [2, с. 15].',
    '',
    'Таблицы и рисунки',
    '- Перед таблицей — строка «Таблица 1 — Название», затем таблица Markdown с заголовками столбцов.',
    '- Рисунок — строка «![Название рисунка](рисунок-1.png)»: в документе останется место под него с подписью.',
    '- На каждую таблицу, рисунок и приложение сошлись в тексте: «в таблице 1», «на рисунке 2», «(приложение А)». В приложении таблицы нумеруй «Таблица А.1».',
    '',
    'Формулы и код',
    '- Формулы — в LaTeX: внутри строки $…$, отдельной строкой $$…$$.',
    '- Сразу после формулы — абзац «где a — …, b — …» с пояснением обозначений.',
    `- Программный код — в блоке ${fence} с указанием языка.`,
    '',
    'Список источников (ГОСТ Р 7.0.100-2018)',
    '- Нумерованный список «1. », источники — в порядке первой ссылки на них в тексте.',
    '- Книга: Иванов, И. И. Название книги : учебник / И. И. Иванов. — Москва : Издательство, 2023. — 256 с.',
    '- Статья: Петров, П. П. Название статьи / П. П. Петров // Название журнала. — 2022. — № 3. — С. 15–20.',
    '- Сайт: Название страницы. — URL: https://example.ru/page (дата обращения: ДД.ММ.ГГГГ).',
    '- Указывай только реально существующие источники. Не придумывай авторов, названия, страницы и ссылки.',
  ].join('\n');
}
